import DocumentTypeStore, {
  FetchDocumentTypes,
} from '../documents/DocumentTypeStore'
import { SupportingItemsPorts } from './ports'
import { computed } from 'mobx'

export class SupportingItemsAdapter implements SupportingItemsPorts {
  constructor(private documentTypesStore: DocumentTypeStore) {}

  @computed
  get documentTypes() {
    return this.documentTypesStore.types.map((t) => t)
  }

  fetchDocumentTypes: FetchDocumentTypes = () =>
    this.documentTypesStore.fetchTypes()
}
